"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormList = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const fab_button_1 = require("../../components/button/fab.button");
const image_button_1 = require("../../components/button/image.button");
const import_poleforeman_button_1 = require("../../components/button/import-poleforeman.button");
const import_button_1 = require("../../components/button/import.button");
const icons_1 = require("../../components/icon/icons");
const spinner_1 = require("../../components/spinner/spinner");
const menu_1 = require("../../components/menu/menu");
const menu_item_1 = require("../../components/menu/menu.item");
const mithril_component_1 = require("../../components/mithril.component");
const table_1 = require("../../components/table/table");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const index_2 = require("../../store/index");
const form_copy_modal_1 = require("../form.copy.modal/form.copy.modal");
const form_share_modal_1 = require("../form.share.modal/form.share.modal");
const form_delete_confirm_modal_1 = require("./form.delete.confirm.modal");
const form_import_ctrl_1 = require("./form.import.ctrl");
const form_import_modal_1 = require("./form.import.modal");
const form_import_poleforeman_modal_1 = require("./form.import.poleforeman.modal");
const form_list_style_1 = require("./form.list.style");
(0, theme_1.addStyles)(form_list_style_1.Style);
/** Display a list of forms */
class FormList extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super();
        this.selectedForm = null;
        this.validIPFLicense = null;
        this.formRefreshLoading = null;
        this.databases = mobx_1.observable.shallowArray();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.checkForValidIPFLicense();
        this.menu = new menu_1.MenuComponent({
            items: () => {
                var _a, _b;
                if (!((_a = services_1.Services.User.current) === null || _a === void 0 ? void 0 : _a.objectId)) {
                    return [];
                }
                const currentUser = services_1.Services.UserProfile.get((_b = services_1.Services.User.current) === null || _b === void 0 ? void 0 : _b.objectId);
                if (!currentUser) {
                    return [];
                }
                return [
                    {
                        view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_DUPLICATE)),
                        action: () => this.copySelectedForm(),
                        visible: services_1.Services.UserProfile.isDepartmentAdmin(currentUser) ||
                            services_1.Services.UserProfile.isDepartmentDataAdmin(currentUser),
                    },
                    {
                        view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_COPY_TO_DEPARTMENT)),
                        action: () => this.confirmCopyForm(),
                        visible: services_1.Services.UserProfile.isDepartmentAdmin(currentUser) ||
                            services_1.Services.UserProfile.isDepartmentDataAdmin(currentUser),
                    },
                    {
                        view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_SHARE)),
                        action: () => this.confirmShareForm(),
                        visible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_FORM_SHARE) &&
                            services_1.Services.Department.moveableDepartments().length > 0 &&
                            (services_1.Services.UserProfile.isDepartmentAdmin(currentUser) ||
                                services_1.Services.UserProfile.isDepartmentDataAdmin(currentUser)),
                    },
                    {
                        view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_REFRESH)),
                        action: () => this.confirmRegenerateIKEPoleForemanForm(),
                        visible: this.refreshFormOptionVisible,
                    },
                    {
                        view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_DELETE)),
                        action: () => this.confirmRemoveForm(),
                        visible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_FORM_DELETE),
                    },
                ];
            },
        });
    }
    copySelectedForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.selectedForm) {
                return;
            }
            yield services_1.Services.Form.copy(this.selectedForm.objectId);
            (0, mobx_1.runInAction)(() => {
                index_2.AppStore.FormSummary.refresh();
            });
        });
    }
    get selectedFormUuid() {
        var _a, _b;
        return (_b = (_a = this.selectedForm) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : null;
    }
    get refreshFormOptionVisible() {
        var _a, _b, _c, _d;
        const isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        if (this.selectedFormUuid == null) {
            return false;
        }
        const form = index_2.AppStore.FormSummary.all.find((summary) => summary.uuid === this.selectedFormUuid);
        const isIPFForm = ((_a = form === null || form === void 0 ? void 0 : form.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) || false;
        if (!isIPFForm) {
            return false;
        }
        const currentOrgAccessId = (_b = services_1.Services.Department.currentOrg) === null || _b === void 0 ? void 0 : _b.accessOrgId;
        if (!currentOrgAccessId) {
            return false;
        }
        const formIsFromSameAccessOrg = ((_d = (_c = form === null || form === void 0 ? void 0 : form.metadata) === null || _c === void 0 ? void 0 : _c.ikePoleForeman) === null || _d === void 0 ? void 0 : _d.accessOrgId) === currentOrgAccessId;
        if (!formIsFromSameAccessOrg) {
            return false;
        }
        const hasValidPermissions = this.validIPFLicense === true && (isIkeAnalyst || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IPF_DB_IMPORT));
        return hasValidPermissions;
    }
    get nodes() {
        const isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        const hasImportToken = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IMPORT_FORM);
        const hasIPFImportToken = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IPF_DB_IMPORT);
        return (0, mithril_1.m)('div', { className: form_list_style_1.CSS.container }, [
            this.viewForms(),
            fab_button_1.FabButton.view({
                title: index_1.T.FORM_CREATE,
                onclick: () => services_1.Services.Route.go(page_1.IkePageName.formNew),
            }),
            ...(isIkeAnalyst || hasImportToken
                ? [
                    import_button_1.ImportButton.view({
                        title: index_1.T.FORM_IMPORT,
                        onclick: () => {
                            const formImportModalCtrl = new form_import_ctrl_1.FormImportCtrl();
                            const formImportModal = new form_import_modal_1.FormImportModal(formImportModalCtrl);
                            formImportModal.open();
                        },
                    }),
                ]
                : []),
            ...(isIkeAnalyst || hasIPFImportToken
                ? [
                    import_poleforeman_button_1.ImportPoleforemanButton.view({
                        title: index_1.T.FORM_NEW_POLEFOREMAN_FORM,
                        onclick: () => {
                            const formImportPoleForemanModal = new form_import_poleforeman_modal_1.FormImportPoleforemanModal({
                                title: index_1.T.FORM_IMPORT_POLEFOREMAN,
                                confirm: index_1.T.FORM_IMPORT_POLEFOREMAN_OK,
                                success: { key: index_1.T.FORM_IMPORT_SUCCEED },
                            });
                            formImportPoleForemanModal.open();
                        },
                    }),
                ]
                : []),
        ]);
    }
    viewForms() {
        if (index_2.AppStore.FormSummary.isLoading) {
            return (0, mithril_1.m)('div', { className: form_list_style_1.CSS.loading }, spinner_1.Spinner.view());
        }
        const headers = [
            '#',
            `${(0, index_1.Translate)(index_1.T.FORM_NAME)} (${(0, index_1.Translate)(index_1.T.FORM_VERSION)})`,
            (0, index_1.Translate)(index_1.T.FORM_DESCRIPTION),
            (0, index_1.Translate)(index_1.T.FORM_UPDATED_AT),
            (0, index_1.Translate)(index_1.T.FORM_CREATED_AT),
            '',
        ];
        const rows = [];
        const forms = index_2.AppStore.FormSummary.all;
        for (let i = 0; i < forms.length; i++) {
            rows.push(this.viewForm(forms[i], i));
        }
        return table_1.Table.view((0, index_1.Translate)(index_1.T.FORM_TITLE), headers, rows);
    }
    viewForm(form, index) {
        let displayName = form.displayname;
        if (form.displayversion && form.displayversion > 0) {
            displayName = `${displayName} (V${form.displayversion})`;
        }
        return [
            (0, mithril_1.m)('span', { className: form_list_style_1.CSS.tableCell }, String(index + 1)),
            (0, mithril_1.m)('a', {
                className: `mdl-button mdl-ripple-effect mdl-button--accent ${form_list_style_1.CSS.tableCell} ${form_list_style_1.CSS.tableCellButton}`,
                title: (0, index_1.Translate)(index_1.T.FORM_EDIT),
                href: services_1.Services.Route.getRouteURL(page_1.IkePageName.formEdit, {
                    version: form.revision,
                }),
            }, displayName),
            (0, mithril_1.m)('div', { className: `${form_list_style_1.CSS.tableCell} ${form_list_style_1.CSS.tableCellFaint} ` }, form.description),
            (0, mithril_1.m)('div', { className: `${form_list_style_1.CSS.tableCell} ${form_list_style_1.CSS.tableCellFaint} ` }, services_1.Services.DateTime.formatDateTime(form.updatedAt)),
            (0, mithril_1.m)('div', { className: `${form_list_style_1.CSS.tableCell} ${form_list_style_1.CSS.tableCellFaint} ` }, services_1.Services.DateTime.formatDateTime(form.createdAt)),
            (0, mithril_1.m)('div', { className: form_list_style_1.CSS.tableCellMenu }, this.viewFormActions(form)),
        ];
    }
    viewFormActions(form) {
        if (!this.menu.hasUsableItems) {
            return null;
        }
        return [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.MORE_VERT, {
                onclick: () => {
                    this.setSelectedForm(form);
                    this.menu.show();
                },
            }),
            this.selectedFormUuid === form.uuid ? this.menu.view() : null,
        ];
    }
    setSelectedForm(form) {
        this.selectedForm = form;
    }
    confirmRemoveForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.selectedFormUuid == null) {
                return;
            }
            const form = index_2.AppStore.FormSummary.all.find((summary) => summary.uuid === this.selectedFormUuid);
            if (!form) {
                return;
            }
            const confirmModal = new form_delete_confirm_modal_1.FormDeleteConfirmModal({
                title: index_1.T.FORM_DELETE_TITLE,
                confirm: index_1.T.FORM_DELETE,
                success: {
                    key: index_1.T.FORM_DELETE_SUCCESS,
                    attrs: {
                        name: form.displayname,
                    },
                },
            }, form);
            confirmModal.open();
        });
    }
    confirmShareForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.selectedFormUuid == null) {
                return;
            }
            const form = index_2.AppStore.FormSummary.all.find((summary) => summary.uuid === this.selectedFormUuid);
            if (!form) {
                return;
            }
            const confirmModal = new form_share_modal_1.FormShareModal({
                title: index_1.T.FORM_SHARE_TITLE,
                confirm: index_1.T.FORM_SHARE,
                success: {
                    key: index_1.T.FORM_SHARE_SUCCESS,
                    attrs: {
                        name: form.displayname,
                    },
                },
            }, form.revision);
            confirmModal.open();
        });
    }
    confirmCopyForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.selectedForm) {
                return;
            }
            const form = index_2.AppStore.FormSummary.all.find((summary) => { var _a; return summary.objectId === ((_a = this.selectedForm) === null || _a === void 0 ? void 0 : _a.objectId); });
            if (!form) {
                return;
            }
            const confirmModal = new form_copy_modal_1.FormCopyModal({
                title: index_1.T.FORM_COPY_TO_DEPARTMENT_TITLE,
                confirm: index_1.T.FORM_COPY_TO_DEPARTMENT,
                success: {
                    key: index_1.T.FORM_COPY_TO_DEPARTMENT_SUCCESS,
                    attrs: {
                        name: form.displayname,
                    },
                },
            }, form);
            confirmModal.open();
        });
    }
    confirmRegenerateIKEPoleForemanForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.selectedFormUuid == null) {
                return;
            }
            const form = index_2.AppStore.FormSummary.all.find((summary) => summary.uuid === this.selectedFormUuid);
            if (!form) {
                return;
            }
            const refreshFormModel = new form_import_poleforeman_modal_1.FormImportPoleforemanModal({
                title: index_1.T.FORM_REFRESH_MODAL_TITLE,
                // confirm and success will not be used
                confirm: index_1.T.FORM_IMPORT_POLEFOREMAN_OK,
                success: {
                    key: index_1.T.FORM_REFRESH_SUCCESS,
                    attrs: {
                        name: form.displayname,
                    },
                },
                cancel: index_1.T.CLOSE,
            }, form.revision);
            refreshFormModel.open();
        });
    }
    checkForValidIPFLicense() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = services_1.Services.Department.rest;
            const ipfLicenseCheckResult = yield rest.Form.Pla.getRefreshPermission({});
            this.validIPFLicense = ipfLicenseCheckResult.success;
        });
    }
}
exports.FormList = FormList;
tslib_1.__decorate([
    mobx_1.observable
], FormList.prototype, "selectedForm", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormList.prototype, "validIPFLicense", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormList.prototype, "formRefreshLoading", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormList.prototype, "databases", void 0);
tslib_1.__decorate([
    mobx_1.computed
], FormList.prototype, "selectedFormUuid", null);
tslib_1.__decorate([
    mobx_1.action
], FormList.prototype, "setSelectedForm", null);
//# sourceMappingURL=form.list.js.map